import React from "react";
import { Button } from "./ui/button";
import { ArrowRight, MapPin, Users, Rocket } from "lucide-react";

const HeroSection = () => {
  const scrollToApplication = () => {
    const element = document.getElementById("apply");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-50 via-white to-amber-50">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-amber-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
        <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-orange-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute bottom-1/4 left-1/3 w-80 h-80 bg-yellow-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Location Badge */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex items-center space-x-2 bg-white/80 backdrop-blur-sm rounded-full px-4 py-2 border border-amber-200 shadow-lg">
            <MapPin className="w-4 h-4 text-amber-600" />
            <span className="text-sm font-medium text-gray-700">Wayanad, Kerala</span>
          </div>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
          Transform Your
          <span className="block bg-gradient-to-r from-amber-500 to-orange-600 bg-clip-text text-transparent">
            Startup Dreams
          </span>
          Into Reality
        </h1>

        {/* Subheading */}
        <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-4xl mx-auto leading-relaxed">
          Empowering rural Wayanad entrepreneurs with world-class mentorship, resources, and connections. 
          Join our 6-month accelerator program and unlock global opportunities.
        </p>

        {/* Stats Row */}
        <div className="flex flex-wrap justify-center items-center gap-8 mb-12">
          <div className="flex items-center space-x-2 bg-white/60 backdrop-blur-sm rounded-lg px-4 py-3 shadow-lg">
            <Users className="w-5 h-5 text-amber-600" />
            <span className="text-gray-700 font-semibold">6-Month Program</span>
          </div>
          <div className="flex items-center space-x-2 bg-white/60 backdrop-blur-sm rounded-lg px-4 py-3 shadow-lg">
            <Rocket className="w-5 h-5 text-amber-600" />
            <span className="text-gray-700 font-semibold">Expert Mentorship</span>
          </div>
          <div className="flex items-center space-x-2 bg-white/60 backdrop-blur-sm rounded-lg px-4 py-3 shadow-lg">
            <MapPin className="w-5 h-5 text-amber-600" />
            <span className="text-gray-700 font-semibold">Free Workspace</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            onClick={scrollToApplication}
            className="bg-gradient-to-r from-amber-500 to-orange-600 hover:from-amber-600 hover:to-orange-700 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-200 group"
          >
            Apply Now
            <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-200" />
          </Button>
          <Button
            onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })}
            variant="outline"
            className="border-2 border-gray-300 text-gray-700 hover:border-amber-500 hover:text-amber-600 px-8 py-4 rounded-full text-lg font-semibold transition-all duration-200"
          >
            Learn More
          </Button>
        </div>

        {/* Extra spacing */}
        <div className="mt-16"></div>
      </div>
    </section>
  );
};

export default HeroSection;